import { render, staticRenderFns } from "./OrdenesServicio.vue?vue&type=template&id=f4716d24&"
import script from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
export * from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
import style0 from "./OrdenesServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f4716d24', component.options)
    } else {
      api.reload('f4716d24', component.options)
    }
    module.hot.accept("./OrdenesServicio.vue?vue&type=template&id=f4716d24&", function () {
      api.rerender('f4716d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/modal-altas/OrdenesServicio.vue"
export default component.exports